export const ENDPOINTS = {
  TOKEN: {
    LOGIN: "login",
    REFRESH: "refresh",
  },
  HISTORY: {
    LIST: (userId: number) => `users/${userId}/history`,
    DELETE: "deleteConfiguration",
  },
  USER: {
    ME: "me",
  },
  STUDIO: {
    PROJECT_CONFIGURATION: "/organizations",
    PROJECT_CATEGORIES: "/studioCategories",
    RETRIEVE_CATEGORIES: "/studioCategories",
    RETRIEVE_STAGES: "/stages",
  },
  STAGES: {
    LIST: "/studioStages",
    RETRIEVE_STAGE: "/studioStages",
    ADMIN_STAGE: "/stages",
  },
  CONFIGURATION: {
    RENDER_CONFIGURATION: "/renderConfiguration",
    RENDER_2D_CONFIGURATION: "/2d/renderConfiguration",
  },
  GLB: {
    renderGLB: "/renderGLB",
  },
  COMPOSITOR: {
    IMAGE: "/compositor/image",
  },
};
